import PropTypes from "prop-types"
import React, { useState } from "react"

const RegistrationRecoveryStep = ({ conflict, initialEmail, onCreateAdmin, onVerifyEmail, onRestart, loading, apiError }) => {
  const [email, setEmail] = useState(conflict.email || initialEmail || "")
  const [emailError, setEmailError] = useState("")

  const verifyEmail = () => {
    const normalizedEmail = email.trim().toLowerCase()
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) {
      setEmailError("Saisissez l’adresse email utilisée lors de la création du compte.")
      return
    }
    onVerifyEmail(normalizedEmail)
  }

  return (
    <section className="partner-page partner-recovery-page">
      <div className="partner-recovery-heading">
        <div className="partner-icon-badge"><i className="bx bx-history" /></div>
        <span className="partner-eyebrow">Inscription déjà commencée</span>
        <h1>Reprenez là où vous vous êtes arrêté</h1>
        <p className="partner-lead">Ce commerce existe déjà dans Wevalo. Choisissez l’action correspondant à l’avancement de votre inscription.</p>
      </div>

      <div className={`partner-recovery-options ${conflict.userExists ? "partner-recovery-options-single" : ""}`}>
        {!conflict.userExists && (
          <article className="partner-recovery-card">
            <span className="partner-recovery-card-icon"><i className="bx bx-user-plus" /></span>
            <div>
              <h2>Créer l’utilisateur administrateur</h2>
              <p>Utilisez cette option si le commerce a été créé, mais qu’aucun accès administrateur n’a encore été ajouté.</p>
            </div>
            <button type="button" className="partner-button partner-button-primary" onClick={onCreateAdmin} disabled={!conflict.registrationToken}>
              Continuer la création <i className="bx bx-right-arrow-alt" />
            </button>
            {!conflict.registrationToken && <small className="partner-recovery-warning">Le token de reprise n’a pas été retourné par l’API. Contactez le support pour créer un nouvel administrateur.</small>}
          </article>
        )}

        <article className="partner-recovery-card partner-recovery-card-verify">
          <span className="partner-recovery-card-icon"><i className="bx bx-envelope" /></span>
          <div>
            <h2>Valider l’adresse email</h2>
            <p>{conflict.userExists
              ? "Votre utilisateur est déjà créé. Recevez un nouveau code OTP pour finaliser la validation de votre adresse email."
              : "Votre utilisateur est déjà créé ? Saisissez son adresse email pour accéder à la validation par code OTP."}</p>
          </div>
          {!conflict.userExists && (
            <div className="partner-field">
              <label htmlFor="partner-recovery-email">Email administrateur</label>
              <input id="partner-recovery-email" type="email" value={email} placeholder="vous@commerce.com" onChange={event => { setEmail(event.target.value); setEmailError("") }} className={emailError ? "is-invalid" : ""} />
              {emailError && <div className="partner-field-error">{emailError}</div>}
            </div>
          )}
          {apiError && <div className="partner-alert partner-alert-danger">{apiError}</div>}
          <button type="button" className="partner-button partner-button-secondary" onClick={() => conflict.userExists ? onVerifyEmail() : verifyEmail()} disabled={loading || conflict.userExists && !conflict.storeId}>
            {loading ? <><span className="partner-spinner" /> Envoi en cours...</> : <>Recevoir mon code OTP <i className="bx bx-right-arrow-alt" /></>}
          </button>
          {conflict.userExists && !conflict.storeId && <small className="partner-recovery-warning">L’identifiant du commerce n’a pas été retourné par l’API. Contactez le support.</small>}
        </article>
      </div>

      <button type="button" className="partner-link-button partner-recovery-restart" onClick={onRestart}><i className="bx bx-left-arrow-alt" /> Rechercher un autre commerce</button>
    </section>
  )
}

RegistrationRecoveryStep.propTypes = {
  conflict: PropTypes.object.isRequired,
  apiError: PropTypes.string,
  initialEmail: PropTypes.string,
  loading: PropTypes.bool,
  onCreateAdmin: PropTypes.func.isRequired,
  onRestart: PropTypes.func.isRequired,
  onVerifyEmail: PropTypes.func.isRequired,
}

export default RegistrationRecoveryStep
